import {
  Box,
  Button,
  Grid,
  GridItem,
  Input,
  Select,
  Text,
  FormControl,
  FormLabel,
  Checkbox,
  Table,
  Tbody,
  Tr,
  Td,
  Thead,
  Th,
  TableContainer,
  Tooltip,
  VisuallyHidden,
  Flex,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { FiUpload } from "react-icons/fi";
import { FileIcon, RemoveIcon } from "../../assets/svgs/Icons";
import { checkFileTypesAndSize, statesList } from "../../Common/utils";
import { toast } from "react-toastify";
import {
  addProcurementForm,
  addSupplier,
  getCompanyData,
  getAllBrokers,
  getOneSupplier,
} from "../../api";
import { useSelector, useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { getAllPrograms } from "../../redux/program/ProgramSlice";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  getProductCategory,
  getProductClassification,
} from "../../redux/product/ProductSlice";
import { INVENTORY_TYPE } from "../../Common/Constants";

function AddThirdPartySupplier() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [farmers, setFarmers] = useState([]);
  const [products, setProducts] = useState([]);
  const [files, setFiles] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const { userData } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const token = localStorage.getItem("cu_user");
  const { productCategory } = useSelector((state) => state.products);
  const { productClassification } = useSelector((state) => state.products);
  const { allPrograms } = useSelector((state) => state.programs);
  const [companyUnits, setCompanyUnits] = useState([]);
  const [allExternalSuppliers, setAllExternalSuppliers] = useState([]);
  const [isOptionSelected, setIsOptionSelected] = useState(false);
  const [supplierDetails, setSupplierDetails] = useState({
    name: "",
    type: "EXTERNAL_CLIENT",
    contact: {
      name: "",
      lastName: "",
      email: "",
      number: "",
    },
    address: {
      raw_address: "",
      city: "",
      state: "",
      pinCode: "",
    },
  });
  const formikRef = React.createRef();

  const handleGoBack = () => {
    navigate("/supplier");
  };

  const addProduct = (product) => {
    setProducts([...products, product]);
  };

  const removeProduct = (index) => {
    setProducts(products.filter((_, i) => i !== index));
  };

  const handleProcurementFileChange = (event) => {
    const file = event.target.files[0];

    const validation = checkFileTypesAndSize(
      file.name,
      file.type,
      file.size,
      10485760
    );

    if (!validation.isValid) {
      setErrorMessage(validation.error);
      toast.error(validation.error);
      return;
    }

    setFiles(file);
    setErrorMessage("");

    toast.success("File Uploaded Successfully");
  };

  const clearErrorMessage = () => {
    setErrorMessage("");
  };

  const getUnit = async () => {
    try {
      const result = await getCompanyData(userData?.companyId);
      setCompanyUnits(result?.data?.company_units);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getAllSuppliers = async () => {
    const response = await getAllBrokers("EXTERNAL_CLIENT");
    setAllExternalSuppliers(response?.data);
  };

  const handleSelectSupplier = async (selectedSupplier) => {
    const response = await getOneSupplier(selectedSupplier);
    const { name, type, contact, address } = response?.data;
    setSupplierDetails({
      name,
      type,
      contact: {
        name: contact?.name,
        lastName: contact?.lastName,
        email: contact?.email,
        number: contact?.number,
      },
      address: {
        raw_address: address?.raw_address,
        city: address?.city,
        state: address?.state,
        pinCode: address?.pinCode,
      },
    });
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Please enter the organization name"),
    // firstName: Yup.string().required("User's First Name is required"),
    // lastName: Yup.string().required("User's Last Name is required"),
    email: Yup.string()
      .email("Invalid email")
      .required("Please enter the organization email"),
    contact: Yup.string().required("Please enter the organization contact"),
    address: Yup.string().required("Please enter the organization address"),
    city: Yup.string().required("Please enter the organization city"),
    // state: Yup.string().required("Please enter the organization state"),
    pinCode: Yup.string().required("Please enter the organization pin code"),
  });

  const getCategories = () => {
    try {
      const result = dispatch(getProductCategory());
      unwrapResult(result);
    } catch (error) {
      console.error(error);
      unwrapResult(error);
    }
  };

  const getClassification = () => {
    try {
      const result = dispatch(getProductClassification());
      unwrapResult(result);
    } catch (error) {
      console.error(error);
      unwrapResult(error);
    }
  };

  const getPrograms = () => {
    try {
      const result = dispatch(getAllPrograms());
      unwrapResult(result);
    } catch (error) {
      console.error(error);
      unwrapResult(error);
    }
  };

  useEffect(() => {
    getAllSuppliers();
    getUnit();
    getCategories();
    getClassification();
    getPrograms();
    handleSelectSupplier(selectedSupplier);
  }, [userData?.companyId, isOptionSelected]);

  useEffect(() => {
    formikRef.current?.setValues({
      ...formikRef.current?.values,
      name: supplierDetails.name || "",
      type: "EXTERNAL_CLIENT",
      firstName: supplierDetails.contact.name || "",
      lastName: supplierDetails.contact.lastName || "",
      email: supplierDetails.contact.email || "",
      contact: supplierDetails.contact.number || "",
      address: supplierDetails.address.raw_address || "",
      city: supplierDetails.address.city || "",
      state: supplierDetails.address.state || "",
      pinCode: supplierDetails.address.pinCode || "",
    });
  }, [supplierDetails]);

  return (
    <Box marginBottom={"3rem"}>
      <Box
        display={"flex"}
        alignItems="center"
        cursor={"pointer"}
        onClick={handleGoBack}
      >
        <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
        &nbsp;
        <Text
          color={"#52BBFF"}
          fontSize={{ base: "sm", md: "sm", lg: "md" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Go Back
        </Text>
      </Box>
      <Grid templateColumns="repeat(3, 1fr)" marginTop={"3rem"}>
        <GridItem>
          <Text
            color={"#141D43"}
            fontSize="2xl"
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            Add Third Party Supplier
          </Text>
          <Text color={" #3958DC"} fontSize="sm">
            Please fill necessary details
          </Text>
        </GridItem>
        <GridItem></GridItem>
      </Grid>
      <Box
        marginTop={"2rem"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft="-2rem"
        marginRight={"-2.5rem"}
        bg={
          "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
        }
        borderTopRightRadius="100px"
        borderBottomRightRadius={"80px 80px"}
      >
        Third Party Supplier Details
      </Box>
      <Formik
        innerRef={formikRef}
        initialValues={{
          name: supplierDetails?.name,
          type: "EXTERNAL_CLIENT",
          firstName: supplierDetails?.contact?.name,
          lastName: supplierDetails?.contact?.lastName,
          email: supplierDetails?.contact?.email,
          contact: supplierDetails?.contact?.number,
          address: supplierDetails?.address?.raw_address,
          city: supplierDetails?.address?.city,
          state: supplierDetails?.address?.state,
          pinCode: supplierDetails?.address?.pinCode,
          country: supplierDetails?.address?.country,
          productType: "",
          productName: "",
          tradeName: "",
          programId: "",
          lotNumber: "",
          productCategory: "",
          productClassification: "",
          description: "",
          unitId: "",
          transportDetails: "",
          purchaseSlipNumber: "",
          date: "",
          netWeight: "",
          grossWeight: "",
          certifiedWeight: "",
          productDocument: "",
          productDocumentName: "",
        }}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          if (products?.length === 0) {
            toast.error("Please add at least one product.");
            return;
          }

          let supplierId;
          if (!selectedSupplier) {
            const supplierData = {
              name: values.name,
              type: values.type,
              contact: {
                name: values.firstName,
                lastName: values.lastName,
                email: values.email,
                number: values.contact,
              },
              address: {
                raw_address: values.address,
                city: values.city,
                state: values.state,
                pinCode: values.pinCode,
              },
            };
            const response = await addSupplier(supplierData);
            if (response?.status === 200) {
              toast.success("Supplier added successfully");
              supplierId = response?.data?.data?._id;
            } else {
              toast.error("Failed to add supplier");
              return;
            }
          } else {
            supplierId = selectedSupplier;
          }
          const finalPayload = {
            supplier: {
              id: supplierId,
              farmer: false,
            },
            procurements: products,
          };

          const finalResponse = await addProcurementForm(
            finalPayload,
            setIsLoading
          );
          if (finalResponse?.status === 200) {
            navigate("/supplier");
            resetForm();
          } else {
            toast.error("Failed to add procurement");
          }
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
          touched,
          errors,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              mt="2rem"
              bg="white"
              p="3rem"
              borderRadius="15px"
              boxShadow="rgba(0, 0, 0, 0.1) 0px 4px 12px"
            >
              <FormControl mb="1rem" maxWidth="300px">
                <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                  Select Previous Third Party Supplier&nbsp;
                  <Text as="span" color="red">
                    *
                  </Text>
                </FormLabel>
                <Select
                  marginTop={"10px"}
                  bgColor="white"
                  color={"#464C64"}
                  border="2px solid  #8fd0fd !important"
                  fontSize="sm"
                  onChange={(e) => {
                    setIsOptionSelected(!isOptionSelected);
                    setSelectedSupplier(e.target.value);
                  }}
                >
                  <option hidden="true">Select Third Party Supplier</option>
                  {allExternalSuppliers?.map((data, index) => (
                    <option value={data?._id} key={index}>
                      {data?.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <Grid templateColumns="repeat(2, 1fr)" gap="1rem" mt="2rem">
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Organization Name&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="name"
                      isDisabled={selectedSupplier}
                      placeholder="Organization Name"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {errors.name && touched.name && (
                      <Text color={"red"} pt="5px">
                        {errors.name}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Supplier Type&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Checkbox
                      mt="1rem"
                      isDisabled
                      isChecked={values.type === "EXTERNAL_CLIENT"}
                    >
                      Third Party Supplier
                    </Checkbox>
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      First Name&nbsp;
                      {/* <Text as="span" color="red">
                        *
                      </Text> */}
                    </FormLabel>
                    <Input
                      type="text"
                      name="firstName"
                      placeholder="Enter Person's Name"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      isDisabled={selectedSupplier}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.firstName}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {/* {errors.firstName && touched.firstName && (
                      <Text color={"red"} pt="5px">
                        {errors.firstName}
                      </Text>
                    )} */}
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Last Name&nbsp;
                      {/* <Text as="span" color="red">
                        *
                      </Text> */}
                    </FormLabel>
                    <Input
                      type="text"
                      name="lastName"
                      isDisabled={selectedSupplier}
                      placeholder="Enter Person's Last Name"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.lastName}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {/* {errors.lastName && touched.lastName && (
                      <Text color={"red"} pt="5px">
                        {errors.lastName}
                      </Text>
                    )} */}
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Email&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="email"
                      type="email"
                      isDisabled={selectedSupplier}
                      placeholder="Organization's Email"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {errors.email && touched.email && (
                      <Text color={"red"} pt="5px">
                        {errors.email}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Contact Number&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      type="number"
                      name="contact"
                      isDisabled={selectedSupplier}
                      placeholder="Organization's Contact Number"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.contact}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {errors.contact && touched.contact && (
                      <Text color={"red"} pt="5px">
                        {errors.contact}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>

                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Address (Location)&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="address"
                      placeholder="Address (Location)"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      isDisabled={selectedSupplier}
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.address}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {errors.address && touched.address && (
                      <Text color={"red"} pt="5px">
                        {errors.address}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      City&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="city"
                      isDisabled={selectedSupplier}
                      placeholder="City"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.city}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {errors.city && touched.city && (
                      <Text color={"red"} pt="5px">
                        {errors.city}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      State&nbsp;
                      {/* <Text as="span" color="red">
                        *
                      </Text> */}
                    </FormLabel>
                    {/* <Select
                      name="state"
                      isDisabled={selectedSupplier}
                      placeholder="State"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="17px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.state}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    >
                      <option hidden="true">Select State</option>
                      {statesList.map((state, index) => (
                        <option key={index}>{state}</option>
                      ))}
                    </Select> */}
                    {/* {errors.state && touched.state && (
                      <Text color={"red"} pt="5px">
                        {errors.state}
                      </Text>
                    )} */}
                    <Input
                      name="state"
                      isDisabled={selectedSupplier}
                      placeholder="State"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.state}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Pincode&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      type="number"
                      name="pinCode"
                      isDisabled={selectedSupplier}
                      placeholder="Pincode"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.pinCode}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {errors.pinCode && touched.pinCode && (
                      <Text color={"red"} pt="5px">
                        {errors.pinCode}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Country&nbsp;
                    </FormLabel>
                    <Input
                      name="country"
                      isDisabled={selectedSupplier}
                      placeholder="Country"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.country}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {errors.country && touched.country && (
                      <Text color={"red"} pt="5px">
                        {errors.country}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>
              </Grid>
            </Box>
            <Box
              marginTop={"3.3rem"}
              color={"#fff"}
              padding={"10px 2rem"}
              fontWeight="700"
              marginLeft="-2rem"
              marginRight={"-2.5rem"}
              bg={
                "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
              }
              borderTopRightRadius="100px"
              borderBottomRightRadius={"80px 80px"}
            >
              Product Details
            </Box>
            <Box
              mt="2rem"
              bg="white"
              p="3rem"
              borderRadius="15px"
              boxShadow="rgba(0, 0, 0, 0.1) 0px 4px 12px"
            >
              <Grid templateColumns="repeat(2, 1fr)" gap="1rem">
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Product Type&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Select
                      marginTop={"10px"}
                      bgColor="white"
                      color={"#464C64"}
                      border="2px solid  #8fd0fd !important"
                      fontSize="sm"
                      name="productType"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    >
                      <option hidden="true">Select Type</option>
                      {Object.keys(INVENTORY_TYPE).map((key) => (
                        <option key={key} value={INVENTORY_TYPE[key]}>
                          {INVENTORY_TYPE[key]}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Program&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Select
                      placeholder="Select Program"
                      name="programId"
                      marginTop={"10px"}
                      bgColor="white"
                      color={"#464C64"}
                      border="2px solid  #8fd0fd !important"
                      fontSize="sm"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    >
                      {allPrograms?.data?.map((data, index) => (
                        <option value={data?._id} key={index}>
                          {data?.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Product&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="productName"
                      placeholder="Product Name"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.productName}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Trade Name&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="tradeName"
                      placeholder="Trade Name"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.tradeName}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Product Category&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>

                    <Select
                      name="productCategory"
                      placeholder="Select Prduct Category"
                      marginTop={"1rem"}
                      bgColor="white"
                      color={"#464C64"}
                      border="2px solid  #8fd0fd !important"
                      fontSize="sm"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    >
                      {productCategory?.data?.map((data, index) => (
                        <option value={data?._id} key={index}>
                          {data?.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Product Classification&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Select
                      name="productClassification"
                      placeholder="Select Product Classification"
                      marginTop={"1rem"}
                      bgColor="white"
                      color={"#464C64"}
                      border="2px solid  #8fd0fd !important"
                      fontSize="sm"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    >
                      {productClassification?.data?.map((data, index) => (
                        <option value={data?._id} key={index}>
                          {data?.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </GridItem>

                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Invoice Number&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="purchaseSlipNumber"
                      placeholder="Invoice Number"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.purchaseSlipNumber}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Invoice Date&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      type="date"
                      name="date"
                      placeholder="Invoice Date"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.date}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Composition&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="description"
                      placeholder="Description"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.description}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Unit&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Select
                      marginTop="1.15rem"
                      name="unitId"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.unitId}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    >
                      <option hidden="true">Select Unit</option>
                      {companyUnits?.map((data, index) => (
                        <option default="true" value={data?._id} key={index}>
                          {data?.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Lot Number&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="lotNumber"
                      placeholder="Lot Number"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.lotNumber}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Transport Document&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="transportDetails"
                      placeholder="Transport Document"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.transportDetails}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
              </Grid>
              <Text fontSize="lg" fontWeight="bold" mt="2rem" mb="1rem">
                Quantity&nbsp;
                <Text as="span" color="red">
                  *
                </Text>
              </Text>
              <Grid templateColumns="repeat(3, 1fr)" gap="1rem">
                <GridItem>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Net Weight&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="netWeight"
                      type="number"
                      placeholder="Net Weight"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      mt="10px"
                      color="#141D43"
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue("isProductSectionVisible", true);
                      }}
                      onBlur={handleBlur}
                      value={values.netWeight}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Gross Weight&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="grossWeight"
                      placeholder="Gross Weight"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      mt="10px"
                      type="number"
                      color="#141D43"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.grossWeight}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Certified Weight&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="certifiedWeight"
                      placeholder="Certified Weight"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      mt="10px"
                      type="number"
                      color="#141D43"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.certifiedWeight}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1} w="175px">
                  <Text
                    color={"#141D43"}
                    fontSize="md"
                    fontWeight={"700"}
                    fontFamily={"font.roboto"}
                  >
                    Document&nbsp;
                    <Text as="span" color="red">
                      *
                    </Text>
                  </Text>
                  <Box mt="1rem">
                    {files ? (
                      <Box
                        display={"flex"}
                        className="overflow-style"
                        boxShadow="rgba(149, 157, 165, 0.2) 0px 8px 24px"
                      >
                        <>
                          <Box bg="#FFFFFF" w={"250px"} borderRadius={"15px"}>
                            <Box display={"flex"} justifyContent={"right"}>
                              <Button
                                borderColor="#FFFFFF"
                                bg="#ffffff"
                                size="sm"
                                variant="outline"
                                onClick={() => setFiles(null)}
                                leftIcon={<RemoveIcon />}
                              ></Button>
                            </Box>
                            <Box display={"flex"} justifyContent={"center"}>
                              <FileIcon />
                            </Box>
                            <Tooltip label={files?.name}>
                              <Text
                                margin={"auto"}
                                width={"130px"}
                                whiteSpace={"nowrap"}
                                overflow={"hidden"}
                                textOverflow={"ellipsis"}
                              >
                                {files?.name}
                              </Text>
                            </Tooltip>
                          </Box>
                        </>
                      </Box>
                    ) : (
                      <Tooltip label="Please exercise caution when uploading a document, as once it has been uploaded, it cannot be removed or changed.">
                        <Button
                          color="blue.400"
                          bg={"#FFFFFF"}
                          leftIcon={<FiUpload />}
                          borderRadius={"15px"}
                          as="label"
                          htmlFor="file-upload"
                          variant="outline"
                        >
                          Upload
                          <VisuallyHidden>
                            <input
                              id="file-upload"
                              type="file"
                              onChange={handleProcurementFileChange}
                            />
                          </VisuallyHidden>
                        </Button>
                      </Tooltip>
                    )}
                  </Box>
                </GridItem>

                <Button
                  mt="1rem"
                  bg="#52BBFF"
                  w="171px"
                  color="white"
                  type="button"
                  isLoading={isLoading}
                  onClick={async () => {
                    if (files !== null) {
                      if (
                        values.productType &&
                        values.productName &&
                        values.tradeName &&
                        values.productClassification &&
                        values.programId &&
                        values.lotNumber &&
                        values.productCategory &&
                        values.description &&
                        values.unitId &&
                        values.transportDetails &&
                        values.purchaseSlipNumber &&
                        values.date &&
                        values.netWeight &&
                        values.grossWeight &&
                        values.certifiedWeight !== null &&
                        values.certifiedWeight !== undefined &&
                        values.certifiedWeight !== ""
                      ) {
                        setIsLoading(true);
                        let procurementFilesRequest;
                        const procurementFilesData = new FormData();

                        procurementFilesData.append("document", files);
                        procurementFilesData.append("doc_type", "OTHER");
                        procurementFilesData.append("userType", "CLIENT");
                        procurementFilesData.append("documentInfo", "OTHER");

                        procurementFilesRequest = await axios({
                          method: "POST",
                          url: `${process.env.REACT_APP_API_HOST}/api/document`,
                          data: procurementFilesData,
                          headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "multipart/form-data",
                          },
                        });
                        setIsLoading(false);
                        if (procurementFilesRequest?.data?.data) {
                          setIsLoading(true);
                          addProduct({
                            type: values.productType,
                            productClassification: values.productClassification,
                            productCategory: values.productCategory,
                            programId: values.programId,
                            productName: values.productName,
                            tradeName: values.tradeName,
                            lotNumber: values.lotNumber,
                            description: values.description,
                            unitId: values.unitId,
                            procurementDocument:
                              procurementFilesRequest?.data?.data?._id,
                            procurementDocumentName:
                              procurementFilesRequest?.data?.data?.name,
                            purchaseSlipNumber: values.purchaseSlipNumber,
                            date: values.date,
                            stockQuantity: {
                              netWeight: values.netWeight,
                              grossWeight: values.grossWeight,
                              certifiedWeight: values.certifiedWeight,
                            },
                            transportDetails: values.transportDetails,
                          });
                          setIsLoading(false);
                          resetForm({
                            values: {
                              ...values,
                              productType: "",
                              productClassification: "",
                              programId: "",
                              productCategory: "",
                              procurementDocument: "",
                              procurementDocumentName: "",
                              purchaseSlipNumber: "",
                              date: "",
                              unitId: "",
                              netWeight: "",
                              grossWeight: "",
                              certifiedWeight: "",
                              lotNumber: "",
                              tradeName: "",
                              productName: "",
                              transportDetails: "",
                              description: "",
                            },
                          });
                          setFiles(null);
                        }
                      } else {
                        toast.error("Please fill all product fields");
                      }
                    } else {
                      toast.error("Please upload the document");
                    }
                  }}
                >
                  Add Product
                </Button>
              </Grid>
            </Box>
            <Box display={"flex"} justifyContent={"center"}>
              {errorMessage && (
                <Box
                  bg="crimson"
                  color="white"
                  p="1rem"
                  borderRadius="15px"
                  mb="1rem"
                  w="60%"
                  textAlign={"center"}
                >
                  {errorMessage}
                  <Button
                    size="sm"
                    variant="outline"
                    ml="1rem"
                    bg="white"
                    color="black"
                    onClick={clearErrorMessage}
                  >
                    <RemoveIcon />
                  </Button>
                </Box>
              )}
            </Box>
            <Button
              bg="#52BBFF"
              color="white"
              mt="2rem"
              w="171px"
              type="submit"
            >
              Add Details
            </Button>
          </form>
        )}
      </Formik>

      {products?.length > 0 && (
        <Box mt="2rem" bg="white" p="3rem" borderRadius="15px">
          <Text fontSize="xl" fontWeight="bold" mb="1rem">
            Products
          </Text>
          <TableContainer className="overflow-style">
            <Table
              variant={"simple"}
              size="md"
              bg={"#fff"}
              borderRadius={"15px"}
              pr={"1rem"}
            >
              <Thead>
                <Tr>
                  <Th color="brand.blue" textTransform="capitalize">
                    Sr no.
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Product
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Trade Name
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Lot Number
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Transport Document
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Net Weight
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Gross Weight
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Certified Weight
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Document
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Action
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {products.map((product, index) => (
                  <Tr key={index}>
                    <Td>{index + 1}</Td>
                    <Td>{product.productName}</Td>
                    <Td>{product.tradeName}</Td>
                    <Td>{product.lotNumber}</Td>
                    <Td>{product.transportDetails}</Td>
                    <Td>{product.stockQuantity.netWeight}</Td>
                    <Td>{product.stockQuantity.grossWeight}</Td>
                    <Td>{product.stockQuantity.certifiedWeight}</Td>
                    <Td>
                      <Tooltip label={product?.procurementDocumentName}>
                        <Text
                          maxWidth="50px"
                          overflow="hidden"
                          textOverflow="ellipsis"
                        >
                          {product?.procurementDocumentName}
                        </Text>
                      </Tooltip>
                    </Td>
                    <Td>
                      <Box
                        cursor="pointer"
                        onClick={() => removeProduct(index)}
                      >
                        <RemoveIcon />
                      </Box>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Box>
  );
}

export default AddThirdPartySupplier;
